import(/* webpackChunkName: "loginLottery" */ 'Feature/LotteryNavigation/code/Styles/loginLottery.scss');
import(/* webpackChunkName: "progressbar" */ 'Feature/Common/code/Styles/progressbar.scss');

await import(/* webpackChunkName: "formValidation" */ 'Feature/Forms/code/Scripts/formValidation');

class UserStatus {
    constructor(url = '#', count = 0) {
        this.count = count;
        this.url = url;
        this.userLoggedIn = false;
    }

    static setup(params) {
        let userStatus = new UserStatus();
        userStatus.count = params.count;
        userStatus.url = params.url;
        userStatus.userLoggedIn = params.userLoggedIn;
        return userStatus;
    }
}

class LoginLottery {
    constructor() {
        this.EmptyCartGKUrl = 'https://www.aktion-mensch.de/lotterie/geschaeftskunden/bestellung';
        this.FilledCartGKUrl = 'https://www.aktion-mensch.de/lotterie/geschaeftskunden/bestellung/uberprufen-und-bestellen';
        this.IsLoginGKApiUrl = window.origin + '/lotterie/api/gk/login/status';
        this.LogoutGKApiUrl = window.origin + '/lotterie/geschaeftskunden/logout';

        this.BackupCartUrl = 'https://www.aktion-mensch.de/lotterie/los-bestellung/warenkorb';
        this.IsLoginApiUrl = window.origin + '/lotterie/checkout/api/shoppingcart/info';
        this.LogoutApiUrl = window.origin + '/lotterie/api/AktionMensch.Shop.Web.Shared.Renderings.Account.Login.Controllers.LoginController%2c%20AktionMensch.Shop.Web/LogoutApi';

        this.CartSSOUrl = window.origin + '/lotterie/shoppingcart';
        this.IsLoginSSOApiUrl = window.origin + '/api/sitecore/LoginApi/IsUserLogin';
        this.LoginSSOApiUrl = window.origin + '/api/sitecore/LoginApi/Login';
        this.LogoutSSOApiUrl = window.origin + '/api/sitecore/LoginApi/Logout';

        this.OrderSSOApiUrl = window.origin + '/api/lotterie/checkout/order/get';
        this.LoginCondition = window.origin + '/api/lotterie/checkout/customer/getlogincondition';
        this.DeleteOrder = window.origin + '/api/lotterie/checkout/order/deleteorder';

        this.Root = '.lottery-header'
        this.LinkWrapperClass = '.metanav_lottery_loginlayer-link';
        this.PopupClass = '.metanav_lottery_loginlayer-link--popup';
        this.PopupButtonClass = '.metanav_lottery_loginlayer-link__collapse';

        this.LoginFormId = '#login-form';
        this.LogoutButtonId = '#logout-button';
        this.LoginButtonId = '#login-button';
        this.UsernameFieldId = '#username-field';
        this.PasswordFieldId = '#password-field';

        this.ErrorClass = '.field-error';
        this.LinkBadgeClass = '.metanav_lottery_loginlayer-badge';
        this.LinkClass = '.metanav_lottery_loginlayer-link--user';
        this.CartClass = '.metanav_lottery_loginlayer-badge--cart';
        this.CartGKClass = '.metanav_lottery_loginlayer-badge--cart-gk';
        this.LoginWrapperClass = '.metanav_lottery_loginlayer-link_login-wrapper';
        this.LogoutWrapperClass = '.metanav_lottery_loginlayer-link_logout-wrapper';
        this.SecureLinkListTileClass = '.lottery-servicehub__tile--secure';

        this.freeLotWarningModal = 'header .free-lot-warning-modal';
        this.LoginWarningModel = 'header .login-warning-modal';
        this.CustomModal = 'header .log-out-custom-modal';
        this.CloseButtonModal = 'header .log-out-close-button';
        this.PrimaryButtonModal = 'header .log-out-modal-button.primary';
        this.SecondaryButtonModal = 'header .log-out-modal-button.secondary';

        this.GKContainer = '.metanav_lottery_loginlayer-link__is-gk';
        this.PKContainer = '.metanav_lottery_loginlayer-link__is-pk';

        this.IsReloadPending = false;

        if (document.querySelector(this.Root).className.indexOf('--in-editor') != -1) {
            return;
        }

        this.$body = $('body');
        this.$dropdowntoggle = $(this.PopupButtonClass);
        this.$loginForm = $(this.LoginFormId);
        this.$loginBtn = $(this.LoginButtonId);
        this.$logoutBtn = $(this.LogoutButtonId);
        this.$customModal = $(this.CustomModal);
        this.$usernameField = $(this.UsernameFieldId);
        this.$passwordField = $(this.PasswordFieldId);
        this.$closeBtnModal = $(this.CloseButtonModal);
        this.$primaryBtnModal = $(this.PrimaryButtonModal);
        this.$secondaryBtnModal = $(this.SecondaryButtonModal);
        this.$LoginWarningModel = $(this.LoginWarningModel);
        this.$FreeLotWarningModal = $(this.freeLotWarningModal);

        this.userStatus = new UserStatus();

        if (window.isGK) {
            // Is GK
            document.querySelectorAll(this.GKContainer).forEach(x => x.style.display = "auto");
            document.querySelectorAll(this.PKContainer).forEach(x => x.style.display = "none");
            // 0: User is logged out, shopping cart has items
            // 1: User is logged in, shopping cart is empty
            // 2: User is logged in, shopping cart has items
            if (this.isMockLoginGK() == '0') {
                this.userStatus.count = 2;
                this.userStatus.url = this.FilledCartGKUrl;
                this.userStatus.userLoggedIn = false;

                this.loginMenuSetup(this.userStatus);
            }
            else if (this.isMockLoginGK() == '1') {
                this.userStatus.count = 0;
                this.userStatus.url = this.EmptyCartGKUrl;
                this.userStatus.userLoggedIn = true;

                this.loginMenuSetup(this.userStatus);
            }
            else if (this.isMockLoginGK() == '2') {
                this.userStatus.count = 2;
                this.userStatus.url = this.FilledCartGKUrl;
                this.userStatus.userLoggedIn = true;

                this.loginMenuSetup(this.userStatus);
            } else {
                this.getLoginUserStatus();
            }
        } else {
            // Is PK
            document.querySelectorAll(this.GKContainer).forEach(x => x.style.display = "none");
            document.querySelectorAll(this.PKContainer).forEach(x => x.style.display = "auto");

            if (this.isMockLogin() == '1') {
                this.userStatus.count = 2;
                this.userStatus.url = this.BackupCartUrl;
                this.userStatus.userLoggedIn = true;

                this.loginMenuSetup(this.userStatus);
            } else if (this.isMockLogin() == '0') {
                this.userStatus.count = 2;
                this.userStatus.url = this.BackupCartUrl;
                this.userStatus.userLoggedIn = false;

                this.loginMenuSetup(this.userStatus);
            } else {
                this.getLoginUserStatus();
            }
        }

        this.clickOutsideInit();
    }

    clickOutsideInit() {
        var self = this;
        this.$passwordField.on("keydown", function (event) {
            if (event.keyCode == 13) {
                self.$loginBtn.trigger('click');
            }
        });

        this.$FreeLotWarningModal.find('button').on('click', function (event) {
            self.modal(false, self.$FreeLotWarningModal);
            if (self.IsReloadPending) {
                self.IsReloadPending = false;
                window.location.reload();
            }
        });

        this.$LoginWarningModel.find('button').on('click', function (event) {
            self.modal(false, self.$LoginWarningModel);
        });

        this.$LoginWarningModel.find('button.secondary').on('click', async function (event) {
            const isDelete = await self.deleteOrder();
            setTimeout(function () {
                $(self.LinkClass).find(self.PopupButtonClass).trigger('click');

                self.$loginBtn.prop("disabled", true);
                const username = self.$usernameField.val()?.trim();
                const password = self.$passwordField.val()?.trim();
                self.loginUser(username, password);
            }, 0);
        });

        this.$dropdowntoggle.on('click', function (event) {
            const parent = $(event.target).closest(self.LinkWrapperClass);
            const button = $(event.target).closest('button.metanav_lottery_loginlayer-link__collapse')
            if (parent.hasClass('active')) {
                parent.removeClass('active');
                parent.children(self.PopupClass).removeClass('show');

                self.metaNavToggleAriaLabel(button);
            } else {
                const parents = $(self.LinkWrapperClass + '.active');
                parents.each(function () {
                    $(this).removeClass('active');
                    $(this).children(self.PopupClass).removeClass('show');
                });

                if (!parent.hasClass('no-popup')) {
                    parent.addClass('active');
                    parent.children(self.PopupClass).addClass('show');
                }

                self.metaNavToggleAriaLabel(button);
            }
        });

        this.$body.on('mouseup', function (event) {
            const isClickInside = event.target.closest(self.LinkWrapperClass);
            if (isClickInside == null) {
                const parent = $(self.LinkWrapperClass + '.active');
                const button = parent.find('button.metanav_lottery_loginlayer-link__collapse')
                parent.removeClass('active');
                parent.children(self.LoginPopupId).removeClass('show');

                self.metaNavToggleAriaLabel(button);
            }
        });

        const loginValidator = self.$loginForm.validate({
            rules: {
                'username-field': {
                    required: true,
                    email: true
                },
                'password-field': {
                    required: true,
                }
            },
            validClass: "success",
            errorClass: "error",
            errorPlacement: function (error, element) {
                const html = `
                <div class="field-error">
                    <div class="message">
                        <span class="info-icon icon icons-information-bold"></span>
                        <p>
                            <span class="field-validation-error">
                                ${error.html()}
                            </span>
                        </p>
                    </div>
                </div>`;

                element.closest('.form-field').find('.field-error').remove();
                $(html).insertAfter(element);
            }
        });

        this.$loginForm.find('input').on('blur', (e) => {
            $(e.target).valid();
        });

        this.$loginForm.on('submit', async (e) => {
            e.preventDefault();

            if (self.$loginBtn.prop("disabled")) {
                return;
            }

            const username = self.$usernameField.val()?.trim();
            const password = self.$passwordField.val()?.trim();

            if (this.$loginForm.valid() && !self.isEmptyOrNull(username) && !self.isEmptyOrNull(password) && self.validateEmail(username.trim())) {
                self.hideError(self);

                const isLoginPossible = await self.canLogin();
                if (!isLoginPossible) {
                    self.modal(true, self.$LoginWarningModel);
                    return;
                }

                self.$loginBtn.prop("disabled", true);
                self.loginUser(username, password);
            } else {
                self.$loginBtn.prop("disabled", false);
                self.showError(self);
            }
        });

        this.$logoutBtn.on('click', function () {
            // show pop-up confirmation if there are items in the cart
            if (self.userStatus.count > 0) {
                self.modal(true);
                return;
            }
            self.logout();
        });

        this.$closeBtnModal.on('click', function () {
            self.modal();
        });

        this.$primaryBtnModal.on('click', function () {
            self.modal();
        });

        this.$secondaryBtnModal.on('click', function (e) {
            e.preventDefault();
            self.logout();
        });
    };

    loginUser(username, password) {
        var self = this;
        // Construct the data object
        var formData = {
            LoginName: username,
            Password: password
        };

        fetch(self.LoginSSOApiUrl, {
            method: 'POST',
            headers: { 'Content-Type': 'application/json' },
            body: JSON.stringify(formData)
        })
            .then(response => response.json())
            .then(response => {
                self.$loginBtn.prop("disabled", false);
                // Handle success response
                if (response.Success || response.ErrorMessage == 'Coupon Code Limit exceeded') {
                    const parent = $(self.$loginBtn).closest(self.LinkWrapperClass);
                    if (parent.hasClass('active')) {
                        parent.removeClass('active');
                        parent.children(self.PopupClass).removeClass('show');
                    }
                    self.userStatus.url = window.isEnableSSO ? this.CartSSOUrl : this.BackupCartUrl;
                    self.userStatus.count = 0;
                    self.userStatus.userLoggedIn = true;

                    self.loginMenuSetup(self.userStatus);

                    if (response.ErrorMessage == 'Coupon Code Limit exceeded') {
                        self.IsReloadPending = true;
                        self.modal(true, loginLottery.$FreeLotWarningModal);
                    } else {
                        // force reset to get updated state of all components
                        window.location.reload();
                    }
                } else {
                    // Display error message
                    self.showError(self);
                }
            })
            .catch(error => {
                self.$loginBtn.prop("disabled", false);
                // Handle error
                self.showError(self);
            });
    }

    async canLogin() {
        try {
            const response = await fetch(this.LoginCondition, { method: 'GET' });
            const result = await response.json();
            if (result.status.code === 'OK') {
                return result.data.IsSafeLoginPossible;
            }
        } catch (error) {
            console.error('Error during login check:', error);
        }
        return true;
    }

    async deleteOrder() {
        try {
            const response = await fetch(this.DeleteOrder, { method: 'DELETE' });
            const result = await response.json();
            if (result.status.code === 'OK') {
                return true;
            }
        } catch (error) {
            console.error('Error during login check:', error);
        }
        return false;
    }

    logout() {
        const url = window.isEnableSSO ? this.LogoutSSOApiUrl : this.LogoutApiUrl;

        fetch(url, { method: 'POST' })
            .then((response) => response.json())
            .then((result) => {
                if (window.isEnableSSO && result) {
                    location.reload(true);
                } else {
                    if (result.status.code === 'OK') {
                        location.reload(true);
                    }
                }
            });
    };

    hide(selector) {
        selector = document.querySelector(selector);

        if (selector) {
            selector.classList.add('d-none');
        }
    };

    show(selector) {
        selector = document.querySelector(selector);

        if (selector) {
            selector.classList.remove('d-none');
        }
    };

    hideError(parent) {
        document.querySelector(parent.LogoutWrapperClass + ' .submit.field-error').style.display = 'none';
    };

    showError(parent) {
        document.querySelector(parent.LogoutWrapperClass + ' .submit.field-error').style.display = 'block';
    };

    validateEmail(email) {
        const re = /^(([^<>()\[\]\\.,;:\s@']+(\.[^<>()\[\]\\.,;:\s@']+)*)|('.+'))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/;
        return re.test(String(email).toLowerCase());
    }

    isEmptyOrNull(str) {
        return (!str || str.trim().length === 0);
    }

    isMockLogin() {
        const url = new URL(window.location.href);
        const searchParams = url.searchParams;
        return searchParams.get('mocklogin');
    };

    isMockLoginGK() {
        const url = new URL(window.location.href);
        const searchParams = url.searchParams;
        return searchParams.get('mockloginGK');
    };

    loginMenuSetup(params) {
        const loginLayer = document.querySelector(this.LinkClass);

        // used later on during sign out
        this.userStatus = params;

        if (params.userLoggedIn) {
            if (window.isGK && !window.showSigninGKPopup) {
                loginLayer.classList.add('no-popup');
            } else if (!window.isGK && !window.showSigninPopup) {
                loginLayer.classList.add('no-popup');
            } else {
                loginLayer.classList.remove('no-popup');
            }

            this.show(`${this.LinkClass} ${this.LinkBadgeClass}`);
            this.show(this.LoginWrapperClass);
            this.hide(this.LogoutWrapperClass);

            this.show(this.SecureLinkListTileClass);
        } else {
            if (window.isGK && !window.showGKPopup) {
                loginLayer.classList.add('no-popup');
                this.hide(this.LinkClass);
            } else if (!window.isGK && !window.showPopup) {
                loginLayer.classList.add('no-popup');
                this.hide(this.LinkClass);
            } else {
                loginLayer.classList.remove('no-popup');
                this.show(this.LinkClass);
            }

            this.hide(`${this.LinkClass} ${this.LinkBadgeClass}`);
            this.hide(this.LoginWrapperClass);
            this.show(this.LogoutWrapperClass);

            this.hide(this.SecureLinkListTileClass);
        }

        const cart = document.querySelector(this.CartClass);
        cart.nextElementSibling.setAttribute('href', params.url);

        if (params.count > 0) {
            cart.innerHTML = params.count;
            if (window.isGK) {
                this.show(this.CartGKClass);
            } else {
                this.show(this.CartClass);
            }
        }
    };

    async getLoginUserStatus() {
        try {
            let response;
            if (window.isEnableSSO) {
                response = await fetch(this.IsLoginSSOApiUrl);
            } else {
                if (window.isGK) {
                    response = await fetch(this.IsLoginGKApiUrl);
                } else {
                    const jwtToken = localStorage.getItem('_checkout-token');
                    response = await fetch(this.IsLoginApiUrl, {
                        headers: {
                            'X-Authorization-Token': `Bearer ${jwtToken}`
                        },
                    });
                }
            }
            const result = await response.json();
            let userStatus = new UserStatus();
            if (window.isEnableSSO) {
                const orders = await this.getOrderStatus();
                userStatus.count = orders;
                userStatus.url = this.CartSSOUrl;
                userStatus.userLoggedIn = result;
            }
            else if (window.isGK) {
                userStatus.count = result?.data?.hasItemsInCart ? 1 : 0;
                userStatus.url = result?.data?.url ? result?.data?.url : this.EmptyCartGKUrl;
                userStatus.userLoggedIn = result?.data?.isLoggedIn;
            }
            else {
                userStatus = UserStatus.setup(result.data);
            }
            this.loginMenuSetup(userStatus);
        } catch (error) {
            console.error('Error fetching user status:', error);
            this.loginMenuSetup(new UserStatus(window.isEnableSSO ? this.CartSSOUrl : (window.isGK ? this.EmptyCartGKUrl : this.BackupCartUrl)));
        }
    }

    async getOrderStatus() {
        try {
            const response = await fetch(this.OrderSSOApiUrl);
            const result = await response.json();
            return await this.getCartItemsNumber(result);
        } catch (error) {
            return 0;
        }
    };

    async getCartItemsNumber(orderResponse) {
        const items = orderResponse?.data?.cartItems;
        const itemsWithoutFreeLots = items?.filter(x => !x.isFreeLot).length ?? 0;
        return itemsWithoutFreeLots;
    }

    modal(show, modal = null, successCallback = null, closeCallback = null) {
        const customModal = modal ?? this.$customModal;

        // Store the close callback for reuse if it's provided
        if (closeCallback) {
            this._closeCallback = closeCallback;
        }

        if (show) {
            this.$body.addClass('modal-open');
            customModal.addClass('show');
            customModal.addClass('d-block');
            customModal.addClass('progressbar__modal-bg');

            if (successCallback) {
                successCallback();
            }
        } else {
            this.$body.removeClass('modal-open');
            customModal.removeClass('show');
            customModal.removeClass('d-block');
            customModal.removeClass('progressbar__modal-bg');

            // Use the stored close callback if it exists
            if (this._closeCallback) {
                this._closeCallback();
                // Optionally, clear the stored callback after use
                this._closeCallback = null;
            }
        }
    };

    updateCart(total) {
        if (typeof total === 'number') {
            document.querySelector(this.CartClass).innerText = total;
        }
    };

    metaNavToggleAriaLabel(button) {
        if (!button || !button.length) {
            return;
        }

        const ariaLabelOld = button.attr('aria-label');

        button.attr('aria-label', button.attr('data-aria-label-toggle'));
        button.attr('data-aria-label-toggle', ariaLabelOld);
    }
}

const loginLottery = new LoginLottery();

window.remainingOrders = (total) => loginLottery.updateCart(total);
window.freeLotWarningModal = (status = true, successCallback = null, closeCallback = null) => loginLottery.modal(status, loginLottery.$FreeLotWarningModal, successCallback, closeCallback);